// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { LinkFragmentDoc } from '../../../../cms/index.generated';
import { ImageLargeFragmentDoc } from '../../../../cms/imageLarge.fragment.generated';
export const SubMenuEditorialContentFragmentDoc = gql`
    fragment subMenuEditorialContent on SubMenuEditorialContent {
  text
  link {
    ...link
  }
  image {
    ...imageLarge
  }
}
    ${LinkFragmentDoc}
${ImageLargeFragmentDoc}`;